export default __webpack_public_path__ + "static/media/01MAR.98fe0020.jpg";